import styled, { keyframes } from 'styled-components';

interface LoadingSpinnerProps {
  size?: 'small' | 'medium' | 'large';
  color?: string;
}

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

const getSizeStyles = (size: string = 'medium') => {
  switch (size) {
    case 'small':
      return {
        width: '16px',
        height: '16px',
        borderWidth: '2px'
      };
    case 'large':
      return {
        width: '48px',
        height: '48px',
        borderWidth: '4px'
      };
    default:
      return {
        width: '24px',
        height: '24px',
        borderWidth: '3px'
      };
  }
};

export const LoadingSpinner = styled.div<LoadingSpinnerProps>`
  ${props => {
    const styles = getSizeStyles(props.size);
    return `
      width: ${styles.width};
      height: ${styles.height};
      border: ${styles.borderWidth} solid #f3f4f6;
      border-top: ${styles.borderWidth} solid ${props.color || '#667eea'};
    `;
  }}
  
  border-radius: 50%;
  animation: ${spin} 1s linear infinite;
  display: inline-block;
`;

export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 200px;
  font-size: 1.1rem;
  color: #64748b;
  flex-direction: column;
  gap: 1rem;
`;